import AnimatedText from './AnimatedText.vue'
import GeneratedContentInfoBar from './GeneratedContentInfoBar.vue'
import HintBar from './HintBar.vue'
import KeywordsGroup from './KeywordsGroup.vue'
import LoadingSpinner from './LoadingSpinner.vue'
import Snackbar from './Snackbar.vue'
import Tour from './Tour.vue'
import WordTag from './buttons/WordTag.vue'

export {
  AnimatedText,
  GeneratedContentInfoBar,
  HintBar,
  KeywordsGroup,
  LoadingSpinner,
  Snackbar,
  Tour,
  WordTag
}



// WEBPACK FOOTER //
// ./src/components/parts/utils/index.js